import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'

export const ACTIVE_NAME_MAP = {
  default: '',
  ubindPhoneConfirm: 'ubind-phone-confirm',
  bindPhone: 'bind-phone',
  ubindPhone: 'ubind-phone'
}

export interface UserItem {
  avatar: string // 头像
  nick: string // 昵称
  is_new_user: boolean // 是否新用户
  register_time: string // 注册时间
  is_tourist: boolean // 是否为游客
  mobile: string // 手机号
  user_name: string // 账号
  is_exist_wx_union: boolean // 是否存在wx_union
  is_exist_qq_union: boolean // 是否存在qq_union
  is_bind_wx: boolean // 是否绑定微信
  is_bind_qq: boolean // 是否绑定QQ
  is_bind_mobile: boolean // 是否绑定手机
  is_account_user: boolean // 是否账号登录用户
  need_update_pwd: boolean // 是否需要修改密码
  vnc_password: number
}

export interface MobileOptions {
  phone: string // 手机号
  code: string // 验证码
  type?: string // 验证码序列号
}

export interface BindPhoneOptions {
  mobile: MobileOptions
  login_type?: number // 登录类型，详情参考登录备注
}

@Injectable()
export class UserInfoEditService {
  constructor (private http: Http) {
  }

  getUserInfo () {
    return this.http.post<{
      user_info: UserItem
    }>('/user/get_info', {})
  }

  updateUserName (user_name: string) {
    return this.http.post('/username/update', {
      user_name
    })
  }

  getVerifyCode (mobile: string) {
    return this.http.post('/user/send_code', {
      mobile,
    })
  }

  bindPhone (options: BindPhoneOptions) {
    return this.http.post<{ user_info: UserItem }>('/user/bind', options)
  }
}
